import React from 'react';
import { Typography, Box, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

const AdminHome = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Welcome to Admin Dashboard
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                This is the main admin page. All admin pages are nested under /admin
            </Typography>
            
            <Stack spacing={2} direction="row">
                <Button 
                    variant="contained" 
                    component={Link} 
                    to="/admin/users"
                >
                    Manage Users
                </Button>
                <Button 
                    variant="outlined" 
                    component={Link} 
                    to="/admin/settings"
                >
                    Settings
                </Button>
                <Button
                    variant="contained"
                    component={Link}
                    to="/admin/articles"
                >
                    Manage Articles
                </Button>
                <Button
                    variant="contained"
                    component={Link}
                    to="/admin/albums"
                >
                    Manage Albums
                </Button>
                <Button
                    variant="outlined"
                    component={Link}
                    to="/admin/announcements"
                >
                    Announcements
                </Button>
            </Stack>
        </Box>
    );
};

export default AdminHome;
